import { render, staticRenderFns } from "./studyInfo.vue?vue&type=template&id=3dc14220&scoped=true"
import script from "./studyInfo.vue?vue&type=script&lang=js"
export * from "./studyInfo.vue?vue&type=script&lang=js"
import style0 from "./studyInfo.vue?vue&type=style&index=0&id=3dc14220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc14220",
  null
  
)

export default component.exports